import React from "react";
import { useTranslation } from "react-i18next";

export const ProjectManagementBannerSection = () => {
  const { t } = useTranslation();

  return (
    <section className="banner-section">
      <div class="project-banner">
        <div class="project-shape-cutout">
          <h1 class="title">{t("project.title")}</h1>
          <p class="quote">
            "You can design and create, and build the most wonderful place in
            the world. But it takes people to make the dream a reality." (Walt
            Disney)
          </p>
        </div>
      </div>
    </section>
  );
};
